import { UserWorkspaceProfile } from "models/UserWorkspaceProfile";
import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";
import { getUsers } from "api/services/user-service";
import { useCallback, useEffect, useState } from "react";

export const useGetUsers = () => {
    const [users, setUsers] = useState<UserWorkspaceProfile[]>([]);
    const { callAPI, loading } = useWorkspaceApiCall(getUsers, '', 'getUsers.error');

    const fetchUsers = useCallback(async () => {
        const resp = await callAPI({});

        if (resp?.success && resp.data) {
            setUsers(resp.data);
        }
    }, [callAPI])

    useEffect(() => {   
        fetchUsers();
    }, [fetchUsers]);

    return { users, fetchingUsers: loading };
}